import styled from 'styled-components'

import Avatar from '../../../../components/display/Avatar'
import ChevronDownIcon from '../../../../components/icons/ChevronDown'
import LazyImage from '../../../../components/display/LazyImage'

const ChevronWrapper = styled.div`
  display: inline-block;

  svg {
    width: 12px;
    vertical-align: middle;
    margin: 0;
  }
`

const Inner = styled.div`
  display: flex;
  align-items: center;

  ${Avatar} {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
  }
`

type AvatarWithChevronProps = {
  avatarUrl: string
}

const AvatarWithChevron = ({ avatarUrl }: AvatarWithChevronProps) => (
  <Inner>
    <Avatar>
      <LazyImage data-src={avatarUrl} alt="Avatar" />
    </Avatar>
    <ChevronWrapper>
      <ChevronDownIcon />
    </ChevronWrapper>
  </Inner>
)

export default AvatarWithChevron
